var AbstractAttributesDialog = require("../attributes/AbstractAttributesDialog");
var Utils = require("common/Utils");

/**
 * @extends {AbstractAttributesDialog}
 * @class
 */
function AttributesDialog() {
    var $htmlForm = $(require("html!./required_attributes_dialog.html"));
    AbstractAttributesDialog.call(this, $htmlForm);

    this.setSubmitEvent("LaunchAttributesController", "post-and-validate-attributes");
}

Utils.inherits(AttributesDialog, AbstractAttributesDialog);

module.exports = AttributesDialog;


//////////////////
// WEBPACK FOOTER
// ./attributes/AttributesDialog.js
// module id = 55
// module chunks = 4